import { styled } from "styled-components";

export const PlayerSearchFilterStyles = styled.div`
    background : ${({ theme }) => theme.playerContentBackground};
`;

export const Foot = styled.div`
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.playerDataBorder};
    background: ${({ theme }) => theme.playerContentBackground};
`;

export const TopPercentiles = styled.div`
    border-bottom: 1px solid ${({ theme }) => theme.playerDataBorder};
`;

export const SelectedAttributes = styled.div`
    border-radius: 2px;
    border: 1px solid ${({ theme }) => theme.playerDataBorder};
    background: ${({ theme }) => theme.dropdownBorderColor};

    .cta-btn-icons {
       fill: ${({ theme }) => theme.ctaIconsColor};
    }
`;

export const AttributesList = styled.div<{ checked: boolean }>`
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.playerDataBorder};
    background: ${({ theme, checked }) => checked ? theme.playerCardBackground : 'none'};
`;

export const PlayerSearchResultsStyled = styled.div`   
    background: ${({ theme }) => theme.searchResultsFooterBackground};
    backdrop-filter: blur(32px); 
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
    -webkit-backdrop-filter:  blur(32px); 
`;

export const PlayerFilterText = styled.div`
    border-bottom: 1px solid ${({ theme }) => theme.playerDataBorder};
`;

export const SelectedPlayerResult = styled.div`
    background: ${({ theme }) => theme.injuryBarColor}
`;

export const SearchPlayerList = styled.div`
    background: ${({ theme }) => theme.playerColor}    
`;

export const AlteredSection = styled.div`
    border-top: 1px solid ${({ theme }) => theme.playerDataBorder};
`;

export const SelectedPlayerAlteredSection = styled.div`
    border-top: 1px solid ${({ theme }) => theme.timeline};
`;

export const SelectedPlayerItem = styled.div`
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.secondaryButtonBorderColor};
    background: ${({ theme }) => theme.playerContentBackground};    

    &:hover {
        background: ${({ theme }) => theme.filterdropdownBackground};
    }

    .view-player-image {
       filter:  ${({ theme }) => theme.mode === 'dark' ? 'invert(100%)' : 'none'};
    }
`;

export const InitialSearchPlayerList = styled.div`
    background: ${({ theme }) => theme.notificationTitleColor};
`;